import { VueExtension } from '../../utils/extensions/vue';
import ScrollView from './scrollview.jsx';
import './scrollview.scss';

VueExtension.WithInstall(ScrollView);

export default ScrollView;
